import { ResizeEditorState, ResizeEditType } from "../../types";

export const pop = (state: ResizeEditorState) => {
    const history = [...state.history];
    history.pop();
    state.history = [...history];
};
